import { render, staticRenderFns } from "./Adduser.vue?vue&type=template&id=2647f2d0"
import script from "./Adduser.vue?vue&type=script&lang=js"
export * from "./Adduser.vue?vue&type=script&lang=js"
import style0 from "./Adduser.vue?vue&type=style&index=0&id=2647f2d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports